import { useNavigate } from 'react-router';
import { PagePath } from '@monorepo/client-types';
import { DesignIcon } from '@monorepo/nova-icons';
import { useConditionalLink, useGetEnvironment } from '../../../hooks';

export const Logo = () => {
  const Link = useConditionalLink();
  const { is5ers } = useGetEnvironment();
  const navigate = useNavigate();

  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(PagePath.Overview);
  };

  return (
    <Link
      href={PagePath.Overview}
      aria-label="Company logo"
      onClick={handleLogoClick}
      style={{
        width: 'auto',
        height: 31,
        padding: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textDecoration: 'none',
      }}
    >
      {is5ers ? (
        <DesignIcon
          useMuiSvgIcon={false}
          iconName="The5ersLogoShort"
          width={47}
          height={31}
        />
      ) : (
        <DesignIcon
          useMuiSvgIcon={false}
          iconName="TTPLogoShort"
          props={{
            sx: { width: 100, height: 32 },
          }}
        />
      )}
    </Link>
  );
};
